<template>
  <div class="workflow-create-stop">
    <div id="map-wrapper">
      <div id="map" />
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import L from "leaflet";
import { mapState } from "vuex";

export default {
  name: "WorkflowCreateStop",
  computed: mapState(["googleCoords"]),
  watch: {
    googleCoords: function(newVal, oldVal) {
      this.console("googleCoords changed, new: ", newVal, " | old: ", oldVal);
      this.updateMarkerLocation();
    }
  },
  data() {
    return {
      map: undefined,
      marker: undefined
    };
  },
  mounted() {
    this.initMap();

    // this event is sent whenever map becomes visible to trigger redraw on next tick
    EventBus.$on("ADDING_STOPS", () => {
      this.$nextTick(() => {
        this.redrawMap();
      });
    });
  },
  methods: {
    updateMarkerLocation() {
      this.map.panTo(this.googleCoords); // setView, flyTo
      this.marker.setLatLng(this.googleCoords); //this.map.getCenter());
    },
    redrawMap() {
      this.map.invalidateSize();
    },
    setStopCoords(coords) {
      this.$store.commit("setStopCoords", coords);
    },
    initMap() {
      // var mapboxToken = `pk.eyJ1Ijoibmlja3R1ayIsImEiOiJjanpxZjNyNWMwZ2JtM2xxc2Qzb3pnaXpqIn0.K0REWPkiR2k4QAwCDjUdHw`;
      // var urlMapbox =`https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=${mapboxToken}`;
      //   var urlOSM = "http://{s}.tile.osm.org/{z}/{x}/{y}.png";
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps
      var bangkokCoords = [13.73114, 100.57529]; // soi 41
      var initialLocation = this.$store.state.googleCoords;
      if (!initialLocation) initialLocation = bangkokCoords;

      this.map = L.map("map", { attributionControl: false });
      this.map.setView(initialLocation, 17);
      this.map.scrollWheelZoom.disable();
      this.map.removeControl(this.map.zoomControl);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 14,
        maxZoom: 19
      }).addTo(this.map);
      this.map.invalidateSize();

      //   var marker = L.circle([51.508, -0.11], {
      this.marker = L.circle(initialLocation, {
        color: "blue",
        fillColor: "red",
        fillOpacity: 100,
        radius: 5
      }).addTo(this.map);

      //   L.marker(bangkokCoords).addTo(this.map);
      //   var marker = L.marker(this.map.getCenter()).addTo(this.map);
      this.map.on("move", () => {
        this.marker.setLatLng(this.map.getCenter());
      });
      //   Dragend event of map for update marker position
      this.map.on("dragend", e => {
        //   var cnt = this.map.getCenter();
        //   var position = marker.getLatLng();
        //   lat = Number(position["lat"]).toFixed(5);
        //   lng = Number(position["lng"]).toFixed(5);
        this.console("marker moved", this.marker, e);
        //   setLeafLatLong(lat, lng);
        this.setStopCoords(this.map.getCenter());
        this.marker.setLatLng(this.map.getCenter());
      });
    }
  }
};
</script>

<style scoped>
/* html,
body, */
#map-wrapper {
  position: relative;
}

#map {
  height: 60vh;
  /* width: 86vw; */
  max-height: none;

  /* position: inherit; */
  /* top: 0;
  bottom: 0;
  right: 0;
  left: 0; */
  width: 100%;
}
</style>